__turbopack_context__.v({
  "root": "styles-module-scss-module__oAkhPG__root",
});
